var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSpeechtotext(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24.287,
    height: 24,
    viewBox: "0 0 24.287 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-6.713 -11)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(4 11)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(8.455)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M36.091,28.932H35v3.886A2.188,2.188,0,0,0,37.182,35H51.364a2.188,2.188,0,0,0,2.182-2.182V13.182A2.188,2.188,0,0,0,51.364,11H37.182A2.188,2.188,0,0,0,35,13.182v3.886h1.091V13.182a1.091,1.091,0,0,1,1.091-1.091H51.364a1.091,1.091,0,0,1,1.091,1.091V32.818a1.091,1.091,0,0,1-1.091,1.091H37.182a1.091,1.091,0,0,1-1.091-1.091Z",
    transform: "translate(-35 -11)",
    fill: "#0080ff"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(10.091 3.273)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M41.545,24.091H55.727a.545.545,0,0,0,0-1.091H41.545a.545.545,0,0,0,0,1.091Z",
    transform: "translate(-41 -23)",
    fill: "#0080ff"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(16.364 6)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M73,33.545A.547.547,0,0,0,72.455,33H64v1.091h8.455A.547.547,0,0,0,73,33.545Z",
    transform: "translate(-64 -33)",
    fill: "#0080ff"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(17.727 8.727)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M76.636,43.545A.547.547,0,0,0,76.091,43H69v1.091h7.091A.547.547,0,0,0,76.636,43.545Z",
    transform: "translate(-69 -43)",
    fill: "#0080ff"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(18.818 11.455)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M79.545,53.545A.547.547,0,0,0,79,53H73v1.091h6A.547.547,0,0,0,79.545,53.545Z",
    transform: "translate(-73 -53)",
    fill: "#0080ff"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(17.727 14.182)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M76.636,63.545A.547.547,0,0,0,76.091,63H69v1.091h7.091A.547.547,0,0,0,76.636,63.545Z",
    transform: "translate(-69 -63)",
    fill: "#0080ff"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(16.364 16.909)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M73,73.545A.547.547,0,0,0,72.455,73H64v1.091h8.455A.547.547,0,0,0,73,73.545Z",
    transform: "translate(-64 -73)",
    fill: "#0080ff"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(10.091 19.636)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M56.273,83.545A.547.547,0,0,0,55.727,83H41.545a.545.545,0,1,0,0,1.091H55.727A.547.547,0,0,0,56.273,83.545Z",
    transform: "translate(-41 -83)",
    fill: "#0080ff"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(16.2 10.8)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 0.995,
    height: 2.7,
    transform: "translate(0 0)",
    fill: "#0080ff"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(13.501 6.301)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 0.9,
    height: 11.7,
    transform: "translate(0 0)",
    fill: "#0080ff"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(11.7 7.2)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 0.9,
    height: 9.9,
    transform: "translate(0 0)",
    fill: "#0080ff"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(9.901 9.001)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 0.9,
    height: 6.3,
    transform: "translate(0 0)",
    fill: "#0080ff"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(8.1 9.9)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 0.9,
    height: 4.5,
    transform: "translate(0 0)",
    fill: "#0080ff"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(5.958 4.365)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1.342,
    height: 14.4,
    transform: "translate(0 0)",
    fill: "#0080ff"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(4.258 8.1)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 0.9,
    height: 8.1,
    transform: "translate(0 0)",
    fill: "#0080ff"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(2.713 8.454)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 0.746,
    height: 6.818,
    fill: "#0080ff"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpeechtotext);
export default __webpack_public_path__ + "static/media/speechtotext.0addd6fd.svg";
export { ForwardRef as ReactComponent };